export default __webpack_public_path__ + "static/media/moltensteelslash2.80161315.png";